import { MutationHookOptions, useMutation } from '@apollo/client'
import gql from 'graphql-tag'
import { Mutation, MutationCreateStorageUnitArgs } from '@/schemaTypes'

const CREATE_CHILD_UNIT = gql`
  mutation createChildUnit(
    $name: String!
    $storageFacilityId: ObjectId
    $parentId: ObjectId
    $capacity: Float
    $isSecureLocation: Boolean
  ) {
    createChildUnit(
      name: $name
      storageFacilityId: $storageFacilityId
      parentId: $parentId
      capacity: $capacity
      isSecureLocation: $isSecureLocation
    ) {
      _id
      name
      storageFacilityId
      childIds
      isSecureLocation
      childUnits {
        _id
        name
        storageFacilityId
        childIds
        childUnits {
          _id
          name
          storageFacilityId
          childIds
          capacity
          isDeleted
        }
        capacity
        isDeleted
      }
      capacity
      isDeleted
    }
  }
`

type TData = { createChildUnit: Mutation['createChildUnit'] }
type TVariables = MutationCreateStorageUnitArgs

export function useCreateChildUnit(
  opts: MutationHookOptions<TData, TVariables> = {},
) {
  const [createChildUnit] = useMutation<TData, TVariables>(
    CREATE_CHILD_UNIT,
    opts,
  )

  return createChildUnit
}
